import { productCardTransportConverterMobile } from "../../card-product/mobile/index.js";
export const carouselProductTransportsConverterMobile = (carousel)=>{
    const { items =[] , link , title ='' , isFirstComponent  } = carousel;
    return {
        props: {
            config: {
                literals: {
                    viewMore: link?.content ?? ''
                }
            },
            title: {
                title: title ?? ''
            },
            items: items?.map((item)=>productCardTransportConverterMobile(item)),
            link,
            isFirstComponent
        }
    };
};
export const tabProductTransportConverterMobile = (tab)=>({
        config: {
            literals: {
                viewMore: tab.data?.link?.content ?? ''
            }
        },
        name: tab.name ?? '',
        title: tab.title ?? '',
        params: tab.arguments ?? [],
        items: tab.data?.items?.map((item)=>productCardTransportConverterMobile(item)),
        link: tab.data?.link
    });

//# sourceMappingURL=index.js.map